const DynatraceScript = () => {
  const scriptSource = "#{HC_DYNATRACE_SOURCE}#";
  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("src", scriptSource);
  script.setAttribute("crossorigin", "anonymous");
  document.head.appendChild(script);
};

export default DynatraceScript;
